import { parseDto } from '../../mappers/parseDto';
import type { Transport } from '../../transport/Transport';

import type { AccountService } from './AccountService';
import { accountOrderDetailEnvelopeDto, accountOrderListDto } from './account.dto';
import {
  toAccountOrderDetail,
  toAccountOrderSummary,
  type AccountOrderDetail,
  type AccountOrderPage,
} from './account.mapper';

export function createLaravelAccountService(transport: Transport): AccountService {
  return {
    async listOrders(page, signal): Promise<AccountOrderPage> {
      const res = await transport.request({
        method: 'GET',
        path: '/account/orders',
        query: { page },
        ...(signal !== undefined ? { signal } : {}),
      });
      const parsed = parseDto(accountOrderListDto, res.data, 'GET /account/orders');
      return {
        orders: parsed.data.map(toAccountOrderSummary),
        page: parsed.meta?.current_page ?? 1,
        lastPage: parsed.meta?.last_page ?? 1,
        perPage: parsed.meta?.per_page ?? parsed.data.length,
        total: parsed.meta?.total ?? parsed.data.length,
      };
    },

    async getOrder(id: string, signal): Promise<AccountOrderDetail> {
      const res = await transport.request({
        method: 'GET',
        path: `/account/orders/${encodeURIComponent(id)}`,
        ...(signal !== undefined ? { signal } : {}),
      });
      const parsed = parseDto(accountOrderDetailEnvelopeDto, res.data, 'GET /account/orders/{id}');
      return toAccountOrderDetail(parsed.data);
    },
  };
}
